var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.dataLoading || _vm.cartLoading
      ? _c("div", { key: 1, staticClass: "loading-overlay" }, [_c("loader")], 1)
      : _c(
          "div",
          { key: "2" },
          [
            _c(
              "div",
              {
                staticClass:
                  "featured-outfits-container page-container featured-occasion"
              },
              [
                _vm._l(_vm.featuredOutfits, function(outfit, index) {
                  return _c("featured-outfit", {
                    key: outfit.outfit_id,
                    attrs: { outfit: outfit, index: index },
                    on: {
                      "shop-items": function($event) {
                        _vm.showShopItems = true
                      },
                      "swap-product": _vm.setSwapProduct
                    }
                  })
                }),
                _vm._v(" "),
                _c(
                  "infinite-loading",
                  {
                    ref: "infiniteLoading",
                    attrs: { spinner: "waveDots" },
                    on: { infinite: _vm.getMoreOutfits }
                  },
                  [
                    _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }, [
                      _vm._v("No more outfits to show!")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "no-outfits-message",
                        attrs: { slot: "no-results" },
                        slot: "no-results"
                      },
                      [_vm._v("No Outfits Match These Filters")]
                    )
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shareLoading,
                    expression: "shareLoading"
                  }
                ],
                key: 1,
                staticClass: "loading-overlay"
              },
              [_c("loader")],
              1
            ),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "fade" } },
              [
                _vm.showSwapProduct
                  ? _c("swap-item", {
                      attrs: { product: _vm.swapProduct },
                      on: { close: _vm.closeSwapModal }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("shop-items", {
              attrs: {
                outfitCurrent: _vm.currentOutfit,
                showShopItems: _vm.showShopItems,
                hideInitialButtons: true
              },
              on: {
                "shop-items": function($event) {
                  _vm.showShopItems = false
                },
                "swap-product": _vm.setSwapProduct
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c574ec", { render: render, staticRenderFns: staticRenderFns })
  }
}